import { useParams } from "react-router-dom";

const useGetUrlLocale = () => {
  const { locale } = useParams();
  return locale ? `/${locale}` : "";
};

export default useGetUrlLocale;